import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import {
  IMG_EXTENSIONS,
  INVALID_PARKING_LAYOUT_FORMAT,
  VALID_PARKING_LAYOUT_EXTENSIONS, MSG_CREATE_PARKING,
  SPOT_TYPE_LABEL,
  USER_ROLES
} from '@shared/constant/shared.constant';
import { FileResponse } from '@core/models/file-response.model';
import { CustomValidator } from '@shared/services/custom-validatior.abstract';
import { ParkingService } from '../services/parking.service';
import { ToastService } from '@shared/services/toast.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { validateInput } from '@shared/services/custom-validatior.abstract';
import { CreateParkingRequest, TruckTypeInput, ParkingLotFacilityInput, ParkingLotImagesInput, ParkingLotSlotsInput } from '@core/models/create-parking-request.model';
import { BreadcrumbItem, CompanyService } from '@shared/services/company.service';
import { CommonFunctions } from '@shared/common-functions';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-parking-slots',
  templateUrl: './parking-slots.component.html',
  styleUrls: ['./parking-slots.component.scss']
})
export class ParkingSlotsComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  parkingPageData: any;
  truckTypes: any[] = [];
  parkingSlotForm!: FormGroup;
  isParkingLayoutError = false
  planDoc = ''
  imageLink = ''
  upldBtn = true
  delIcon = false
  isParkingLotLayoutDoc: boolean | null = null;
  formData = new FormData();
  isProfileImgError = false;
  pdfUrl = '';
  isParkAnywhere: boolean = false;
  selectedTab: string = 'defineSlots';
  companyId : string;
  role : string;
  userRoles = USER_ROLES;
  constructor(private readonly fb: FormBuilder,
    private readonly dialogControlService: DialogControlService,
    private readonly parkingService: ParkingService,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly encryptStorage: EncryptionStorageService) {

  }
  ngOnInit(): void {
    this.role = this.encryptStorage.getItem('roleName');
    this.companyId = this.encryptStorage.getItem('companyId');
    
    const breadcrumbObj: BreadcrumbItem[] = [
          {
            title: 'Parking Locations',
            url: `${CommonFunctions.routeToBookingDetail(this.role)}/parking-list/${this.companyId}`,
          },
          {
            title: 'Create Parking',
          },
        ];
        this.companyService.setAdminHeaders('0', breadcrumbObj);
    this.parkingPageData = this.getDataFromStorage('parkingFirstPage');
    this.truckTypes = this.getDataFromStorage('truckData');
    this.buildForm();
    this.optionalCharges();

  }

  ownerManagerRedirection(): string | void {
    if (this.role === this.userRoles.PARKING_MANAGER || this.role === this.userRoles.PARKING_OWNER) {
      return `${CommonFunctions.routeToBookingDetail(this.role)}/parking-list/${this.companyId}`;
    }
  }
  toggleIsParkAnywhere(): void {
    this.selectedTab = 'parkAnywhere'; // Update the selectedTab value
    this.isParkAnywhere = !this.isParkAnywhere;
    this.updateTotalSlotsValidatorForAllTruckTypes()
  }
  updateTotalSlotsValidatorForAllTruckTypes(): void {
    const truckTypeControls = this.parkingSlotForm.get('truckTypeArray') as FormArray;

    for (let i = 0; i < truckTypeControls.length; i++) {
      const totalSlotsControl = truckTypeControls.at(i).get('totalSlots');

      if (this.selectedTab === 'parkAnywhere') {
        totalSlotsControl?.clearValidators();
      } else {
        totalSlotsControl?.setValidators(Validators.required);
      }

      totalSlotsControl?.updateValueAndValidity();
    }
  }

  buildForm(): void {
    this.parkingSlotForm = this.fb.group({
      totalSlots: ['', [Validators.required, CustomValidator.validateGreaterThanZero,CustomValidator.validateLessThanThousand]],
      thresholdValue: ['', [Validators.required, CustomValidator.validateGreaterThanZero, CustomValidator.validateLessThanHundred]],
      truckTypeArray: this.fb.array([])
    });
    this.bindTruckArrayData();

  }
  bindTruckArrayData() {
    this.truckTypes.forEach((trucksArray: any) => {
      if (Array.isArray(trucksArray)) {
        trucksArray.forEach((truck: any) => {
          this.truckTypeArray().push(this.addNewTruck(truck));
        });
      } else {
        this.truckTypeArray().push(this.addNewTruck(trucksArray));
      }
    });
  }

  addNewTruck(truck: any): FormGroup {
    return this.fb.group({
      id: [truck.spotTypeId, [Validators.required]],
      truckName: [truck.spotType],
      totalSlots: ['', [Validators.required, CustomValidator.validateGreaterThanZero, CustomValidator.validateLessThanThousand]],
      parkingSlots: this.fb.array([])
    }) as FormGroup;
  }

truckTypeArray(): FormArray {
    return this.parkingSlotForm.get("truckTypeArray") as FormArray
  }

  parkingSlotArray(slotIndex: number): FormArray {
    return this.truckTypeArray().at(slotIndex).get("parkingSlots") as FormArray
  }

  addNewParkingSlot(name: string) {
    return this.fb.group({
      slotName: [name, [Validators.required]],
    })
  }

  getDataFromStorage(key: string) {
    return JSON.parse(this.encryptStorage.getItem(key) ?? "")
  }
  soltChange(truckForm: any): void {
    const total = truckForm.get('totalSlots').value;
    const slots = truckForm.get('parkingSlots') as FormArray;
    this.clearFormArray(slots);

    const startChar = "A";
    if(truckForm.get('totalSlots').value <1000){
      for (let startVal = 1; startVal <= total; startVal += 1) {
        const slotVal = startVal < 10 ? `0${startVal}` : startVal;
        slots.push(this.addNewParkingSlot(`${startChar}${slotVal}`));
      }
    }
  }

  clearFormArray(formArray: FormArray): void {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }
  
  createParking(): void {
    for (const slot of this.parkingSlotForm.value.truckTypeArray[0].parkingSlots) {
      if (slot.slotName.trim() === '') {
        this.toastService.showToastMessage('error', 'Error', 'Slot name cannot be blank.');
        break;
      }
    }
    if (this.parkingSlotForm.valid) {
      const createParkingRequest: CreateParkingRequest = {
        name: this.parkingPageData.name,
        hazardousLoadRate: +this.parkingPageData.hazardousLoadRate,
        isHazardousLoad: this.parkingPageData.isHazardousLoad,
        termsAndCondition: CommonFunctions.htmlEncode(this.parkingPageData.oneTimeBookingsInstruction?.replace(/<img[^>]*>/g, '')),
        offer: +this.parkingPageData.offer,
        rating: 0,
        companyLogo: null,
        aboutUs: null,
        parkingLotLayout: this.isParkingLotLayoutDoc ? this.planDoc : this.imageLink,
        isParkingLotLayoutDoc: this.isParkingLotLayoutDoc,
        totalNumberOfSlots: this.parkingSlotForm.get('totalSlots')?.value,
        thresholdValue: this.parkingSlotForm.get('thresholdValue').value,
        taxAndFees: +this.parkingPageData.taxAndFees,
        location: this.parkingPageData.location,
        isParkAnywhere: this.isParkAnywhere !== null ? this.isParkAnywhere : false,
        truckType: this.getSelectedTruckTypes(),
        parkingLotSpotTypeSpecialRateInput: (this.parkingPageData.specialRates),
        parkingLotFacility: this.getSelectedFacilities(),
        parkingLotImages: this.getSelectedParkingImages(),
        parkingLotSlots: this.getSelectedParkingLotSlots(),
        termsAndConditionRecurring: CommonFunctions.htmlEncode(this.parkingPageData?.recurringBookingsInstruction?.replace(/<img[^>]*>/g, '')),
        termsAndConditionFilePath: this.parkingPageData?.termsAndConditionFilePath,
        accessCode: this.parkingPageData?.oneTimeAccessCode,
        monthlyAccessCode: this.parkingPageData?.monthlyTimeAccessCode,
      }
      if(this.role === this.userRoles.SUPER_ADMIN){
        createParkingRequest.companyId= this.companyId;
      }
      let valid = true;
      if (this.selectedTab == 'defineSlots') {
        createParkingRequest.truckType.forEach((truck: TruckTypeInput) => {
          if (valid && truck.numberOfSlots > createParkingRequest.totalNumberOfSlots) {
            this.toastService.showToastMessage('error', 'Error', `Number of spots for '${truck.vehicleName}' can not be more than total number of spots`);
            valid = false;
          }
        });
      }

      if (valid) {
        this.parkingService.createParkingLot(createParkingRequest)
        .pipe(autoUnsubWith(this.destroyRef))
        .subscribe({
          next: () => {
            localStorage.removeItem('truckData');
            localStorage.removeItem('parkingFirstPage');
            
            this.openSuccessModal();
          },
          error: (err: HttpErrorResponse) => {
            
            this.toastService.showToastMessage('error', 'Error', err.error.message);
          }
        })
      }
    }
    else {
      CustomValidator.markFormGroupTouched(this.parkingSlotForm);
    }
  }
  getSelectedTruckTypes(): any[] {
    const type: TruckTypeInput[] = [];
    const selectedTruck: any[] = this.parkingPageData.truckTypeArray;
    const truckTypeArrayFromForm: any[] = this.parkingSlotForm.value.truckTypeArray;
    truckTypeArrayFromForm.forEach((truck) => {
      const matchingTruck = selectedTruck.find(x => x.spotTypeId === truck.id);
      if (matchingTruck) {
        const truckTypeInput: any = {
          vehicleTypeId: truck.id,  
          vehicleName: truck.truckName,  
          numberOfSlots: +truck.totalSlots,  
          fareChargesDaily: +matchingTruck.dailyRate, 
          fareChargesMonthly: +matchingTruck.monthlyRate, 
        };
        type.push(truckTypeInput);
      }
    });
    return type;
  }
  getSelectedFacilities(): ParkingLotFacilityInput[] {
    const type: ParkingLotFacilityInput[] = [];
    const parkingLotFacility: any[] = this.parkingPageData.parkingLotFacility;

    parkingLotFacility.forEach((facility) => {
      type.push({
        facilityId: facility
      })
    })
    return type;
  }
  getSelectedParkingImages(): ParkingLotImagesInput[] {
    const type: ParkingLotImagesInput[] = [];
    const parkingPhotoData: any[] = this.parkingPageData.parkingPhotos;

    parkingPhotoData.forEach((url) => {
      type.push({
        imagePath: url
      })
    })
    return type;
  }
  getSelectedParkingLotSlots(): ParkingLotSlotsInput[] {
    const type: ParkingLotSlotsInput[] = [];
    if (this.selectedTab === 'parkAnywhere') {
      return type
    }
    this.truckTypeArray().controls.forEach((truck, index) => {
      const slotArray = this.parkingSlotArray(index);
      slotArray.controls.forEach((slot) => {
        type.push({
          vehicleTypeId: truck.get("id")?.value,
          slotName: slot.get("slotName")?.value
        })
      });
    });
    return type;
  }
  prevParkingPageData: any;
  optionalCharges() {
    this.parkingPageData.truckTypeArray.forEach(truck => {
      truck.isHourlyCharge = !(truck.hourly === null || truck.hourly === undefined);
      truck.isDailyCharge = !(truck.daily === null || truck.daily === undefined);
      truck.isWeeklyCharge = !(truck.weekly === null || truck.weekly === undefined);
      truck.isMonthlyCharge = !(truck.monthly === null || truck.monthly === undefined);
    });
  }

  openSuccessModal(): void {
    this.dialogControlService.openDialog(SuccessModalComponent, {
      data: {
        bodyText: MSG_CREATE_PARKING
      }
    });
  }

  onUpload(files: any, fileUpload: any) {
    const img = files[0].name;
    const fileExtension = img.split('.').pop();
    const file = files[0];
    const maxSize = 25 * 1024 * 1024;
    if (!VALID_PARKING_LAYOUT_EXTENSIONS.includes(fileExtension.toLowerCase())) {
      fileUpload.clear();
      this.toastService.showToastMessage('error', 'Error', INVALID_PARKING_LAYOUT_FORMAT);
      return
    }
    else if (file.size > maxSize) {
      this.isProfileImgError = true;
      fileUpload.clear()
      return
    }
    
    this.isProfileImgError = false
    this.formData.append('Images', file);
    this.parkingService.imageUplaod(this.formData)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response: FileResponse) => {
          const data = response;
          for (const key in data) {
            if (data.hasOwnProperty(key)) {
              const url = data[key];

              if (IMG_EXTENSIONS.includes(fileExtension.toLowerCase())) {
                this.imageLink = url;
                this.upldBtn = false;
                this.delIcon = true;
                this.isParkingLotLayoutDoc = false;
              }
              else {
                this.pdfUrl = url;
                this.planDoc = url
                this.upldBtn = false;
                this.delIcon = true;
                // File extension is not valid
                this.isParkingLotLayoutDoc = true;
              }
            }
          }
          
        }
      })
  }
  deleteDocument(): void {
    this.formData = new FormData();
    this.imageLink = '';
    this.pdfUrl = '';
    this.upldBtn = true;
    this.delIcon = false;
    this.isParkingLotLayoutDoc = null;
  }
  onDrop(event: any, fileUpload: any): void {
    event.preventDefault();
    const files = event.dataTransfer.files;
    this.onUpload(files, fileUpload);
  }

  onDragOver(event: any): void {
    event.preventDefault();
  }

  onDragLeave(event: any): void {
    event.preventDefault();
  }

  onKeyPress(event: KeyboardEvent): void {
    if (!validateInput(event)) {
      event.preventDefault();
    }
  }
}
